import React from "react";

import { videoDetailDates } from "../../../../helpers/convertDate";
import { toMinutes } from "../../../../helpers/convertTime";

import RevShared from "./RevShare";
import VideoDetailsWrapper from "./styles/VideoDetails.style";

function VideoDetails(props) {
  const { auth, additionalInfo, video, isMobile } = props;
  const {
    publishingTitle,
    isHD,
    signedDate,
    duration,
    jmId,
    originalPublishingDate,
    location,
  } = video;

  return (
    <VideoDetailsWrapper>
      <div className="title__wrapper">
        <h2 className="title">{publishingTitle}</h2>
        {isHD && <span className="isHd">HD</span>}
      </div>
      <div className="additional__wrapper">
        <div className="fields">
          <span className="label">Date Added: </span>
          <span className="value">{videoDetailDates(signedDate)}</span>
        </div>
        <div className="fields">
          <span className="label">Length: </span>
          <span className="value">{toMinutes(duration)}</span>
        </div>
        <div className="fields">
          <span className="label">JV#:</span>
          <span className="value">{jmId}</span>
        </div>

        {isMobile && (
          <div className="fields">
            <span className="label">Date Posted:</span>
            <span className="value">
              {originalPublishingDate
                ? videoDetailDates(originalPublishingDate)
                : signedDate
                ? videoDetailDates(signedDate)
                : "N/A"}
            </span>
          </div>
        )}

        {isMobile && (
          <div className="fields">
            <span className="label">Location:</span>
            <span className="value">{location || "Unavailable"}</span>
          </div>
        )}

        <RevShared auth={auth} additionalInfo={additionalInfo} />
      </div>
    </VideoDetailsWrapper>
  );
}

export default VideoDetails;
